import {HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';
import {ApiErrorModel} from '@models/api/@base/api-error.model';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from 'angular2-notifications';
import {locale as czech} from 'app/i18n/cs';
import {locale as english} from 'app/i18n/en';
import {environment} from 'environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    silentEndpoints = [
        /\/AdvisorDashboard\/ManagerBonus/,
        /\/Contract\/.*\/SendToHeadquartes/
    ];

    constructor(
        private notificationsService: NotificationsService,
        private fuseTranslationLoaderService: FuseTranslationLoaderService,
        private translateService: TranslateService,
    ) {
        this.fuseTranslationLoaderService.loadTranslations(czech, english);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                // show in console
                if (!environment.production) {
                    console.log('ErrorInterceptor', req, error);
                }

                if (this.silentEndpoints.find(e => req.url.match(e)) == null) {
                    // process bad request
                    if (error.status === 400 && error.error) {
                        const apiError: ApiErrorModel = error.error;
                        if (apiError.value) {
                            // InnerError shoudl be handled in specific Api
                            if (apiError.value.code !== 'InnerError') {
                                this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), this.translateService.instant(`ERROR_CODE.${apiError.value.code.toUpperCase()}`));
                            }
                        } else if (apiError.errors) {
                            const errKeys = Object.keys(apiError.errors);
                            errKeys.forEach(errKey => {
                                this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `${errKey}: ${apiError.errors[errKey]}`);
                            });
                        } else {
                            if (typeof apiError === 'object') {
                                const errMsg: string[] = [];
                                for (const key of Object.keys(apiError)) {
                                    errMsg.push(`${key}: ${apiError[key]}`);
                                }
                                this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `Chyba v těchto atributech:\n${errMsg.join('\n')}`);
                            } else {
                                this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `Chyba v těchto atributech: ${apiError}`);
                            }
                        }
                    } else {
                        // ignore not found
                        if (error.status !== 404) {
                            this.notificationsService.error(this.translateService.instant(`HTTP.${error.status}`), `URL: ${req.url.replace(environment.BaseApiUrl, '')}`);
                        }
                    }
                }
                return throwError(() => error);
            })
        );

    }

}

export const ErrorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
};
